import React from 'react';
import {langsValue} from 'app/utils/langs/langsValue';
import CompendiumAnswerInterface from 'app/interfaces/CompendiumAnswerInterface';


interface Props {
  isMyPredictionPage?: boolean;
  answer?: CompendiumAnswerInterface;
  correct_answers?: CompendiumAnswerInterface[];
  isCalculated: boolean;
  isCorrectAnswer: boolean;
}

const EM_DASH = '\u2014';

const correctAnswers = (isCalculated: boolean, correct_answers: CompendiumAnswerInterface[]): string => {
    if (!isCalculated) {
        return EM_DASH;
    }

    return correct_answers.map(correctAnswer => langsValue(correctAnswer, 'answer')).join('; ') || EM_DASH;
};

const RenderUserAnswer: React.FC<Props> = (props: Props): React.ReactNode => {
    const {answer, correct_answers, isMyPredictionPage, isCalculated, isCorrectAnswer} = props;

    if (isMyPredictionPage) {
        return <div className="compendium-grid__item-answer">
            {!isCorrectAnswer && isCalculated && <span>{correctAnswers(isCalculated, correct_answers)}</span>}
            <span>
                {correct_answers.length > 1 && isCorrectAnswer ? correctAnswers(isCalculated, correct_answers) : langsValue(answer, 'answer')}
            </span>
        </div>;
    }
    return <></>;
};

export default RenderUserAnswer;
